export enum ButtonVariant {
	Primary = "Primary",
	PrimaryOutline = "PrimaryOutline",
	Secondary = "Secondary",
	SecondaryOutline = "SecondaryOutline",
}

// TODO sizes of buttons

export function getButtonClass(variant: ButtonVariant): string {
	const commonClassesForLargeButtons =
		"inline-block tracking-[0.01em] text-center text-base shadow-2xs xl:text-base border-2 md:px-8 px-6 rounded-full py-3 max-w-[28.75rem] w-fit min-w-[15rem] font-bold cursor-pointer";

	switch (variant) {
		case ButtonVariant.Primary:
			return `${commonClassesForLargeButtons} text-white border-transparent bg-primary hover:bg-primary-hover transltion-all duration-200 ease-in-out hover:box-shadow-xl`;
		case ButtonVariant.Secondary:
			return `${commonClassesForLargeButtons} text-white bg-primary border-transparent`;
		case ButtonVariant.PrimaryOutline:
			return `${commonClassesForLargeButtons} border-primary bg-white text-primary border-primary hover:border-primary-hover transition-all hover:text-primary-hover`;
		case ButtonVariant.SecondaryOutline:
			return `${commonClassesForLargeButtons} text-white bg-secondary border-transparent`;
	}
}
